import { useState, useEffect } from "react";
import Input from "../input/Input";
import style from "./Registration-style.module.css";
import validateInput from "../../utilities/validations/validateInput";
import { contactInformationDetails } from "../../stores/slices/einSlice";
import { useDispatch, useSelector } from "react-redux";
import { DROPDOWN_STATES } from "../../constant/Constants";
import { toast } from "react-toastify";
import Loader from "../menu/Loader";
import { smartyStreetApi } from "../../stores/slices/smartyStreetSlice";
import { language } from "../../stores/slices/languageSlice";
import { lookUp } from "../../stores/slices/lookupSlice";
const PartnerForm = ({ partnerFormDetails, setPartnerformDetails }) => {
  const lookUpData = useSelector(lookUp);
  // get content with store
  const selectedLanguage = useSelector(language).Registrations.providerForm;
  //get Smart street data from store
  const smartySreetStoreData = useSelector((state) => state.smartyStreetSlice);
  const dispatch = useDispatch();

  const inputOnchane = (e) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let fieldvalidation = e.target.getAttribute("fieldvalidation");
    let inputValidate = validateInput(inputValue, fieldvalidation);
    if (name == "Phone_Number") {

      setPartnerformDetails((preinfo) => ({
        ...preinfo,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
          errorMsg: inputValidate.errorMsg
        },
      }));
    }else if(name == "Fax_Number"){
      setPartnerformDetails((preinfo) => ({
        ...preinfo,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.value.length > 0 ? inputValidate.isValid : true,
          errorMsg: inputValidate.errorMsg
        },
      }));
    } else if (name == "Address" || name == "Zip_Code" || name == "State" || name == "City") {
      setPartnerformDetails((preinfo) => ({
        ...preinfo,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
        smartyStreetMatches: {
          IsValid: false,
          NoMatch: false,
          PartialMatch: false,
          ExactMatch: false,
          SecInfoNotMatch: false
        },
        ss_msg: "",
        ss_msg_cls: "",
      }));
    } else {
      setPartnerformDetails((preinfo) => ({
        ...preinfo,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
      }));
    }
  };
  const verifyAddres = () => {
    let formValidate =
      partnerFormDetails.Organization_Name.value != "" &&
      partnerFormDetails.Organization_Name.isValid &&
      partnerFormDetails.Address.value != "" &&
      partnerFormDetails.Address.isValid &&
      partnerFormDetails.City.value != "" &&
      partnerFormDetails.City.isValid &&
      partnerFormDetails.State.value != "" &&
      partnerFormDetails.State.isValid &&
      partnerFormDetails.Zip_Code.value != "" &&
      partnerFormDetails.Zip_Code.isValid;

    if (!formValidate) {
      setPartnerformDetails((prevState) => ({
        ...prevState,
        Organization_Name: {
          value: partnerFormDetails.Organization_Name.value,
          isValid:
            partnerFormDetails.Organization_Name.value != "" && partnerFormDetails.Organization_Name.isValid ? true : false,
        },
        Phone_Number: {
          value: "",
          isValid: partnerFormDetails.Phone_Number.value != "" && partnerFormDetails.Phone_Number.isValid ? true : false,
          errorMsg: false
        },
        Fax_Number: {
          value: "",
          isValid: partnerFormDetails.Fax_Number.value != "" && partnerFormDetails.Fax_Number.isValid ? true : false,
          errorMsg: false
        },
        Address: {
          value: partnerFormDetails.Address.value,
          isValid: partnerFormDetails.Address.value != "" && partnerFormDetails.Address.isValid ? true : false,
        },
        City: {
          value: partnerFormDetails.City.value,
          isValid: partnerFormDetails.City.value != "" && partnerFormDetails.City.isValid ? true : false,
        },
        State: {
          value: partnerFormDetails.State.value,
          isValid: partnerFormDetails.State.value != "" && partnerFormDetails.State.isValid ? true : false,
        },
        Zip_Code: {
          value: partnerFormDetails.Zip_Code.value,
          isValid: partnerFormDetails.Zip_Code.value != "" && partnerFormDetails.Zip_Code.isValid ? true : false,
        },
      }));
      toast.error(selectedLanguage?.toastError);
    } else {
      let address = {
        addressLine1: partnerFormDetails.Address.value,
        addressLine2: "",
        city: partnerFormDetails.City.value,
        state: partnerFormDetails.State.value,
        zipCode: partnerFormDetails.Zip_Code.value,
      };

      dispatch(smartyStreetApi({ address, callbackVerifiedAddress }));
      dispatch(contactInformationDetails(partnerFormDetails));
    }
  };

  const callbackVerifiedAddress = (address) => {

    if (address?.isValidateAddress != undefined && address.isValidateAddress == "ExactMatch") {
      setPartnerformDetails((prevState) => ({
        ...prevState,

        Address: {
          value: address.street,
          isValid: address.street != "" ? true : false,
        },
        City: {
          value: address.city,
          isValid: address.city != "" ? true : false,
        },
        State: {
          value: address.state,
          isValid: address.state != "" ? true : false,
        },
        Zip_Code: {
          value: address.zipcode,
          isValid: address.zipcode != "" ? true : false,
        },
        smartyStreetMatches: {
          IsValid: address.IsValid,
          NoMatch: address.NoMatch,
          PartialMatch: address.PartialMatch,
          ExactMatch: address.ExactMatch,
          SecInfoNotMatch: address.SecInfoNotMatch
        },
        ss_msg: selectedLanguage?.verifyAddressSucces,
        ss_msg_cls: "ss_success",
        isAppAddressValid: true,
      }));
    } else {
      setPartnerformDetails((preState) => ({
        ...preState,
        Address: {
          value: address.street,
          isValid: address.street != "" ? true : false,
        },
        City: {
          value: address.city,
          isValid: address.city != "" ? true : false,
        },
        State: {
          value: address.state,
          isValid: address.state != "" ? true : false,
        },
        Zip_Code: {
          value: address.zipcode,
          isValid: address.zipcode != "" ? true : false,
        },
        smartyStreetMatches: {
          IsValid: address.IsValid,
          NoMatch: address.NoMatch,
          PartialMatch: address.PartialMatch,
          ExactMatch: address.ExactMatch,
          SecInfoNotMatch: address.SecInfoNotMatch
        },
        ss_msg: selectedLanguage?.verifyAddressError,
        ss_msg_cls: "ss_error",
        isAppAddressValid: false,
      }));
    }
  };
  return (
    <>
      <div
        className={`grid input-fields columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5 container ${style.editform}`}
      >
        <Input
          type="text"
          id="OrganizationName"
          label={selectedLanguage?.organizationName}
          name="Organization_Name"
          value={partnerFormDetails.Organization_Name.value}
          onChange={(e) => inputOnchane(e)}
          isValid={partnerFormDetails.Organization_Name.isValid}
          errorMsg={selectedLanguage?.errorMsg}
          fieldvalidation="name"
          disabled="disabled"
        />
        <Input
          type="text"
          id="PhoneNumber"
          label={selectedLanguage?.phoneNumber}
          name="Phone_Number"
          maxLength="12"
          value={partnerFormDetails.Phone_Number.value}
          onChange={(e) => inputOnchane(e)}
          isValid={partnerFormDetails.Phone_Number.isValid}
          errorMsg={partnerFormDetails.Phone_Number.errorMsg ? "Phone/Fax number cannot begin with the number one" : selectedLanguage?.errorMsg}
          fieldvalidation="phoneNumber"
        />
        <Input
          type="text"
          id="FaxNumber"
          label={selectedLanguage?.fax}
          name="Fax_Number"
          maxLength="12"
          value={partnerFormDetails.Fax_Number.value}
          onChange={(e) => inputOnchane(e)}
          isValid={partnerFormDetails.Fax_Number.isValid}
          errorMsg={partnerFormDetails.Fax_Number.errorMsg ? "Phone/Fax number cannot begin with the number one" : selectedLanguage?.errorMsg}
          fieldvalidation="faxnumber"
        />
        <Input
          type="text"
          id="Address"
          label={selectedLanguage?.Adderss}
          name="Address"
          value={partnerFormDetails.Address.value}
          onChange={(e) => inputOnchane(e)}
          isValid={partnerFormDetails.Address.isValid}
          errorMsg={selectedLanguage?.errorMsg}
          fieldvalidation="address"
        />
        <Input
          type="text"
          id="City"
          label={selectedLanguage?.city}
          name="City"
          value={partnerFormDetails.City.value}
          onChange={(e) => inputOnchane(e)}
          isValid={partnerFormDetails.City.isValid}
          errorMsg={selectedLanguage?.errorMsg}
          fieldvalidation="city"
        />
        <Input
          type="select"
          id="State"
          label={selectedLanguage?.state}
          name="State"
          value={partnerFormDetails.State.value}
          onChange={(e) => inputOnchane(e)}
          isValid={partnerFormDetails.State.isValid}
          errorMsg={selectedLanguage?.errorMsg}
          fieldvalidation="state"
          elmentconfig={lookUpData.State}
        />
        <Input
          type="text"
          id="ZipCode"
          label={selectedLanguage?.zipcode}
          name="Zip_Code"
          value={partnerFormDetails.Zip_Code.value}
          onChange={(e) => inputOnchane(e)}
          isValid={partnerFormDetails.Zip_Code.isValid}
          errorMsg={selectedLanguage?.errorMsg}
          fieldvalidation="zipcode"
        />
      </div>
      <div>
        <div className={`${partnerFormDetails.ss_msg_cls}`}>
          {partnerFormDetails.ss_msg}
        </div>
        <div className="pt-3">
          {" "}
          <button
            onClick={verifyAddres}
            className={`btn ${style.verifyAddres}`}
          >
            {" "}
            {selectedLanguage?.verifyAdreesBtn}
          </button>
        </div>
      </div>
      {smartySreetStoreData?.smartyStreetData.loader && <Loader />}
    </>
  );
};

export default PartnerForm;
